import { render, staticRenderFns } from "./InventoryCardTray.vue?vue&type=template&id=20112889"
import script from "./InventoryCardTray.vue?vue&type=script&lang=js"
export * from "./InventoryCardTray.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports